import React, { useEffect, useState } from 'react';
import { View, Text, ScrollView, StyleSheet, TouchableOpacity } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { TextInput } from '../../atoms/textinput';
import { Button } from '../../atoms/button';
import LandlordAndAgentInfo from './landloardInfo';
import Modal from '@material-ui/core/Modal';
import CheckoutForm from '../commanBuyCertificate/checkoutForm';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import { tenantActions } from '../../../redux/tenant.actions';
import success from "./../../../../../assets/images/success.svg";
import failed from "./../../../../../assets/images/failed.png";
import { AntDesign } from '@expo/vector-icons';
const STRIPEKEY = 'pk_live_51MlCEgFCJVtBrQ2WrFpZjfEbieiBD6GaxyoY5mQsOe7Sxfkj6qHvaIMxEshrwCvNnjqV2IJ2SoE0xs8ip6DVlRnc00l6X5Hl3u';

const RentalWarrentyPopup = ({
  visible,
  heading,
  subHeading,
  onOkPress,
  onCancelPress,
  type,
  data,
  propertyId
}) => {
  const [clientSecret, setClientSecret] = React.useState('');
  const open_flow_landlords = useSelector((state) => state.tenant?.flowIdInfo.open_flow_landlords);
  const stripePromise = loadStripe(STRIPEKEY);
  const [page, setPage] = React.useState(1);

  const dispatch = useDispatch()
  const [state, setState] = useState({
    type,
    title: '',
    name: '',
    first_name: '',
    last_name: '',
    correspondence_address: '',
    post_code: '',
    email: '',
    number: '',
    warranty: '',
    commission: '',
    price: '',
    source:"hubita",
    agent:{
      address:"uk",
      postcode:"",
      name:"Hubita",
      telephone:"0000000000",
      email:"Info@hubita.co.uk"
    },
  });

  useEffect(() => {
    setState(prev => ({ ...prev, type }));
  }, [type]);

  useEffect(() => {
    if (data) {
      setState(prev => ({
        ...prev,
        warranty: data?.name || '',
        commission: data?.commission || '',
        price: data?.price || '',
      }));
    }
  }, [data]);

  const getLeadLandlord = () => {
    const leadLandlord = open_flow_landlords?.find((landlord) => landlord.is_lead);
    if (leadLandlord) {
      return leadLandlord;
    } else if (landlords?.length > 0) {
      return landlords[0];
    } else {
      return {};
    }
}
  useEffect(() => {
    if (open_flow_landlords?.length) {
      setState(prev => ({
        ...prev,
        email: getLeadLandlord()?.email,
        title: getLeadLandlord()?.title,
        number: getLeadLandlord()?.number,
        post_code: getLeadLandlord()?.post_code,
        last_name: getLeadLandlord()?.last_name,
        first_name: getLeadLandlord()?.first_name,
        correspondence_address: getLeadLandlord()?.correspondence_address,
      }));
    }
  }, [open_flow_landlords]);
  const [showModal, setShowModal] = React.useState(false);
console.log("state",state)
  useEffect(() => {
    setShowModal(visible);
  }, [visible]);
  const renderpage1 =()=>{
    return(
      <View>
      <TouchableOpacity onPress={onCancelPress} style={styles.closeBtn}>
             <Text style={styles.closeText}>×</Text>
           </TouchableOpacity>
 
           <ScrollView contentContainerStyle={styles.content}>
             <Text style={styles.heading}>{heading}</Text>
 
             <View style={styles.subHeadings}>
               {subHeading.map((item, index) => (
                 <Text key={index} style={styles.subText}>{item}</Text>
               ))}
             </View>
               <LandlordAndAgentInfo
               landlord={state}
               />
             {type === 'buy' && (
               <>
                 <View style={styles.inputRow}>
                   <Text style={styles.label}>Warranty: {state?.warranty}</Text>
                  
                 </View>
                 <View style={styles.inputRow}>
                   <Text style={styles.label}>Total Cost:£ {state?.price}</Text>
                 </View>
               </>
             )}
 
             {type === 'earn' && (
               <View style={styles.inputRow}>
                 <Text style={styles.label}>Commission:`£ ${state?.commission}`</Text>
               </View>
             )}
 
             <Text style={styles.confirm}>Are you happy with the costs and OK to proceed?</Text>
 
             <View style={styles.buttonRow}>
               <Button
                 onClick={onCancelPress}
                 title="No"
                 type="stripe"
                 style={{ borderColor: '#FC4850', color: '#FC4850' }}
               />
               <Button
                 onClick={() =>{
                 
                   let data ={
                      "hubita_product_id":"Rental_warrenty",
                       "name":state?.warranty,
                       "price":state?.price,
                       "is_active":true,
                       "amount":state?.price,
                       "property_id": propertyId
                       }
                       // data = {"hubita_package_id":1,"name":"Individual","price":6,"vat":1.2,"number_of_flows":1,"is_active":true,"createdAt":"2025-05-02T07:30:23.353Z","updatedAt":"2025-05-02T07:30:23.353Z","amount":6}
 
                   dispatch(tenantActions.buyFlowPackage(data, (daraaa) => {
                     setClientSecret(daraaa?.data?.clientSecret)
                     setPage(2)
                   }));
                 }}
                 title="Yes"
                 type="stripe"
                 style={{ borderColor: '#90C418', color: '#90C418' }}
               />
             </View>
 
             <Text style={styles.noteTitle}>PLEASE NOTE:</Text>
             <Text style={styles.noteText}>
               By clicking yes you agree to OpenBrix invoicing you at the end of every month for this reference.
             </Text>
           </ScrollView>
     </View>
    )
 
  }
  const renderSuccess = () => {
    return (
      <View style={styles.modalContainer}>
        <img src={success} style={{ height: 100, marginTop: 20 }} />

        <Text
          marginBottom={30}
          marginTop={40}
          style={{ alignSelf: "center" ,marginBottom:30,marginTop:40,fontSize:26, fontWeight:700,color:"black",textAlign:"center"}}
          >
          Payment Successfull!
        </Text>

        <View style={{ backgroundColor: "#1B8A8C", width: 100, height: 2, alignSelf: "center", marginBottom: 20 }} />
        <TouchableOpacity
          onPress={() => {
  onOkPress(state)
          }}
          style={{
            marginTop: 10,
            paddingHorizontal: 20,
            backgroundColor: "white", borderColor: "#536DFE",
            borderWidth: 1,
            boxShadow: "0px 2px 11px 1px rgba(0,0,0,0.09)",
            alignSelf: "center",
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: 10,
            paddingVertical: 10,
            flexDirection: "row"
          }}
        >
          <Text
            style={{ alignSelf: "center" ,fontSize:20, fontWeight:700,color:"#536DFE"}}
           >
            Continue
          </Text>
          <AntDesign
            style={{ marginLeft: 20 }}
            name="arrowright" size={24} color="#536DFE" />
        </TouchableOpacity>
        <Text
          style={{ marginTop:30, alignSelf: "center" ,textAlign:"center", fontSize:20, fontWeight:400,color:"black"}}
         >
          Thank you for your payment. Please click continue to buy your rental warrenty.
        </Text>
        <Text
           style={{ marginTop:10, alignSelf: "center" ,textAlign:"center", fontSize:20, fontWeight:400,color:"black"}}>
          You will receive confirmation of this payment via email.
        </Text>
      </View>
    )
  }
  const renderFail = () => {
    return (
      <View style={styles.modalContainer}>
        <img src={failed} style={{ height: 30, width:30,alignSelf:"center", marginTop: 20 }} />

        <Text
          marginBottom={30}
          marginTop={40}
          style={{ alignSelf: "center" ,marginBottom:30,marginTop:40,fontSize:26, fontWeight:700,color:"black"}}
          >
          Payment Failed!
        </Text>

        <View style={{ backgroundColor: "#1B8A8C", width: 100, height: 2, alignSelf: "center", marginBottom: 20 }} />
        <TouchableOpacity
          onPress={() => {
    setPage(1)
          }}
          style={{
            marginTop: 10,
            paddingHorizontal: 20,
            backgroundColor: "white", borderColor: "#536DFE",
            borderWidth: 1,
            boxShadow: "0px 2px 11px 1px rgba(0,0,0,0.09)",
            alignSelf: "center",
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: 10,
            paddingVertical: 10,
            flexDirection: "row"
          }}
        >
          <Text
            style={{ alignSelf: "center" ,fontSize:20, fontWeight:700,color:"#536DFE"}}
           >
            Retry
          </Text>
          <AntDesign
            style={{ marginLeft: 20 }}
            name="arrowright" size={24} color="#536DFE" />
        </TouchableOpacity>
       
      </View>
    )
  }
  const renderStripe =()=>{
    return(
      <View style={{
        width: "100%", marginTop: 40,
        maxHeight: "70vh",
        padding: 20, backgroundColor: "white", borderTopRightRadius: 18, borderBottomLeftRadius: 18, backgroundColor: "white",
        boxShadow: "0px 2px 11px 1px rgba(0,0,0,0.09)",
        alignSelf: "center",
        overflow: "scroll"
      }}>
        <Text
          style={{ marginBottom: 30, fontSize: 26, fontWeight: "700", color: "#1B8A8C" }}
        >
          Checkout:
        </Text>
        <View style={{
          borderRadius: 8,
          borderColor: "#1B8A8C",
          borderWidth: 1,
          marginBottom: 30,
          boxShadow: "0px 2px 11px 1px rgba(0,0,0,0.09)",
          padding: 20
        }}>
          <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
            <Text

              style={{ marginBottom: 30, fontSize: 18, fontWeight: "500", color: "#1B8A8C" }}>
        {state?.warranty}
            </Text>
          

          </View>
          <Text
            style={{  fontSize: 24, fontWeight: "700", color: "#1B8A8C" }}
          >
            Total Cost:  £ {state?.price.toFixed(2)}
          </Text>
        </View>
        <Elements
          stripe={stripePromise}
          options={{
            clientSecret: clientSecret,
          }}

        >
          <CheckoutForm
            onSuccessToken={(success) => {
              if (success) {
                setPage(3);
            } else {
                setPage(4);
            }
            }}
            onCancel={()=>{
              setPage(1)
            }}
          />
        </Elements>
      </View>
    )
  }
  return (
    <Modal
      open={showModal}
      onBackdropPress={onCancelPress} backdropOpacity={0.3}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingLeft: 10,
        paddingRight: 10,
        flex: 1
      }}
    >
      <View style={styles.overlay}>
        <View style={styles.container}>
         {page==1? renderpage1():null}
         {page==2? renderStripe():null}
         {page==3? renderSuccess():null}
         {page==4? renderFail():null}



        </View>
      </View>
    </Modal>
  );
};

export default RentalWarrentyPopup;

const styles = StyleSheet.create({
  overlay: {
    backgroundColor: 'white',
    borderRadius: 16,
    padding: 20,
    width: '100%',
    maxWidth: 600,
    alignSelf: 'center',
  },
  container: {
    borderRadius: 16,
    paddingVertical: 24,
    paddingHorizontal: 28,
    width: '100%',
  },
  closeBtn: {
    position: 'absolute',
    right: 16,
    top: 12,
    zIndex: 1,
  },
  closeText: {
    fontSize: 28,
    fontWeight: '600',
    color: '#6D08C0',
  },
  content: {
    paddingBottom: 20,
  },
  heading: {
    fontSize: 22,
    fontWeight: '700',
    color: '#333',
    marginBottom: 10,
  },
  subHeadings: {
    marginBottom: 16,
  },
  subText: {
    fontSize: 15,
    marginBottom: 4,
    color: '#666',
  },
  inputRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginVertical: 10,
  },
  label: {
    fontSize: 16,
    fontWeight: '500',
    color: '#444',
    width: '40%',
  },
  inputWrap: {
    width: '58%',
  },
  inputFull: {
    width: '100%',
  },
  confirm: {
    fontSize: 16,
    fontWeight: '600',
    textAlign: 'center',
    marginTop: 20,
    marginBottom: 12,
    color: '#222',
  },
  buttonRow: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    marginBottom: 20,
    marginTop: 10,
  },
  noteTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 4,
  },
  noteText: {
    fontSize: 13,
    color: '#888',
    lineHeight: 18,
    textAlign: 'center',
  },
});

